import React, { useState, useEffect } from "react";
import InventoryForm from "./InventoryForm";
import { Column, Row } from "simple-flexbox";
import { selectCartRefundTotal } from "../../../../../redux-store/reducers/cart-reducer/cart.selector";
import Naira from "react-naira";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Autorenew from "@material-ui/icons/Autorenew";
import Popup from "../../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../../utilities/Notification";
import ConfirmDialog from "../../../../utilities/ConfirmDialog";
import AddRefundForm from "./AddRefundForm";
import AddInventoryCount from "./AddInventoryCount";
// import InventoryCorrection from './InventoryCorrection';
import TestImage from "../../../../../assets/images/amala.jpeg";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    // margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "isActive", label: "Product Name" },
  { id: "isActive", label: "Product" },
  { id: "locationName", label: "Cost" },
  { id: "locationAddress", label: "Quantity" },
];

export function Inventory({
  locations,
  AddInventory,
  total,
  LoadInventories,
  AddRefund,
  inventories,
  refundItems,
  products,
  AddInventoryCorrection,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(refundItems, headCells, filterFn);

  useEffect(() => {
    // LoadInventories(localStorage.getItem('userId'));
    return () => { };
  }, []);

  var submit = () => {
    if (refundItems.length == 0) {
      alert("you cannot refund empty item");
    } else {
      AddRefund(refundItems);
    }
  };
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const twenty = 20000;

  const addOrEdit = (inventory, resetForm) => {
    if (inventory.id === 0) AddInventory(inventory);
    else var data = { ...inventory };
    AddInventory(data);
    resetForm();
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    //   DeleteLocation(id)
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  const [refundType, setRefundType] = React.useState("");

  const handleChange = (event) => {
    setRefundType(event.target.value);
  };
  return (
    <>
      <div className="container" style={{ paddingTop: "1rem" }}>
        <div style={{}}>
          <Column flexGrow={1}>
            <ToastContainer />
           

            <Paper className={classes.pageContent}>
              <h4>
                {" "}
                <strong>Refunds</strong>
              </h4>
              <div
                className="container row p-0 m-0"
                style={{
                  width: "35rem",
                  position: "relative",
                  left: "23rem",
                }}
              >
                <div className="col">
                  <Toolbar>
                    <Controls.Button
                      text="Add Item to Refund"
                      variant="outlined"
                      startIcon={<AddIcon />}
                      className={classes.newButton}
                      onClick={() => {
                        setAddOpenPopup(true);
                        setRecordForEdit(null);
                      }}
                    />
                  </Toolbar>
                </div>
              </div>

              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.dateCreated}>
                      <TableCell>{item.productName}</TableCell>
                      <TableCell>
                        <img
                          src={item.imageId}
                          height="60px"
                          width={"60px"}
                          alt="No-Image"
                        />
                      </TableCell>
                      <TableCell>{item.amount}</TableCell>
                      <TableCell>
                        <strong>{item.quantityRefunded}</strong>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <h2>Total Amount {total}</h2>
              <TblPagination />
              <div className="col pt-4">
                <Toolbar>
                  <FormControl>
                    <InputLabel id="demo-simple-select-label">
                      Refund Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={refundType}
                      label="Refunds"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Cash</MenuItem>
                      <MenuItem value={20}>Transfer</MenuItem>
                      <MenuItem value={30}>Cheque</MenuItem>
                    </Select>
                  </FormControl>
                </Toolbar>
                <Toolbar>
                  <Controls.Button
                    text="Refund"
                    variant="contained"
                    onClick={() => submit()}
                    startIcon={<Autorenew />}
                  />
                </Toolbar>
              </div>
            </Paper>

            <Popup
              title="Add Refund Form"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddRefundForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                locations={locations}
                products={products}
              />
            </Popup>

            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  console.log(state)
  return {
    locations: state.locationReducer.locationDrop,
    total: selectCartRefundTotal(state),
    products: state.productReducer.productList,
    refundItems: state.cartReducer.refundItems,
    inventories: state.inventoryReducer.inventories,
  };
}
const mapDispatchToProps = (dispatch) => ({
  AddRefund(payload) {
    dispatch({ type: "ADD_REFUND", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
